/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */

/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */
import type { Filter } from './types';

class MessageSubscriber {
  public readonly filter: Filter;
  public readonly messageHandler: Function;
  public readonly contextName?: string;

  constructor(filter: Filter, messageHandler: Function, contextName?: string) {
    this.filter = filter;
    this.messageHandler = messageHandler;
    this.contextName = contextName;
  }
}

export default MessageSubscriber;
